(function () {
  // Get URL parameter
  function getParam(name) {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get(name) || "";
    } catch {
      return "";
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    const resultsEl = document.getElementById("marketResults");
    const paginationWrap = document.querySelector(".market-list-pagination");
    const resultsNum = document.getElementById("resultsNum");
    const form = document.querySelector(".cav-market-list-form");
    const input = form ? form.querySelector('[name="market_search"]') : null;

    if (!resultsEl || !paginationWrap || !form || !window.marketList) return;

    function setLoading(on) {
      const ring = document.querySelector(".loading-ring");
      if (!ring) return;
      ring.classList.toggle("is-active", !!on);
    }

    function scrollToResults() {
      // Smooth scroll to the top of the results section
      resultsEl.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function updateUI(htmlPosts, htmlPagination, total) {
      if (typeof htmlPosts === "string") {
        resultsEl.innerHTML = htmlPosts;
      }

      if (typeof htmlPagination === "string") {
        paginationWrap.innerHTML = htmlPagination;
      }

      if (typeof total === "number" && resultsNum) {
        resultsNum.textContent = `Showing ${total} results.`;
      }

      attachPaginationHandlers();
      scrollToResults();
    }

    function fetchPage(page = 1, search = "") {
      setLoading(true);

      fetch(marketList.ajaxurl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          action: "lcswma_market_list",
          page: page,
          search: search,
        }),
      })
        .then((r) => r.json())
        .then((r) => {
          if (!r.success) {
            console.error(r);
            return;
          }

          const data = r.data || {};
          updateUI(
            data.posts || "",
            data.pagination || "",
            data.total ?? undefined,
          );
        })
        .catch((err) => {
          console.error("Market list AJAX error: ", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }

    function attachPaginationHandlers() {
      const buttons = paginationWrap.querySelectorAll("[data-page]");
      if (!buttons.length) return;

      buttons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          const page = parseInt(btn.getAttribute("data-page"), 10) || 1;
          const searchVal = (input && input.value.trim()) || "";
          fetchPage(page, searchVal);
        });
      });
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (input) input.blur();
      const value = (input && input.value.trim()) || "";
      fetchPage(1, value);
    });

    attachPaginationHandlers();
  });
})();
